import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

import { ListUserDetailsDTO } from '@bb/domain/dist/types';
import {
  AddressSearch,
  ContactSearch,
  Layout,
  Icon,
  IconNameType,
  Title,
  Paragraph,
  Contact,
  Button,
} from 'components';

import { ContactController } from 'api';

import iconLibrary from '../../../components/Icon/iconLibrary';
import { Prediction } from '../../../components/AddressSearch/types';
import { ParsedDetailsResult } from '../../../components/AddressSearch/PlacesService';
import { ContactDrawerType } from '../../ContactDrawer/types';
import { SetupBrokerageWizardModalContext } from '../../../contexts';

const IconText = styled.p``;

const DevPage: React.FC = () => {
  const [addressResult, setAddressResult] =
    useState<ParsedDetailsResult>(undefined);
  const [listingResult, setListingResult] =
    useState<ListUserDetailsDTO['listings'][number]>(undefined);
  const [contact, setContact] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [partner, setPartner] = useState<any>(null);
  const { openModal } = React.useContext(SetupBrokerageWizardModalContext);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        const { contact: result } = await ContactController.getContactById(
          '5fd7af145795255e1e6a1e13',
        );

        setContact(result);
      } catch (err) {
        console.log(err);
      }

      setLoading(false);
    };

    fetchData();
  }, []);

  const [contacts, setContacts] = useState<any>([]);

  useEffect(() => {
    (async () => {
      try {
        // const data = await ContactController.getContactsByOwners(['a', 'b']);
        // setContacts(data);
      } catch (err) {
        console.log(err);
      }
    })();
  }, []);

  return (
    <Container>
      <Button onClick={openModal}>Open Setup Brokerage Modal</Button>
      <LeftContainer>
        <AddressSearchContainer>
          <Title>ADDRESS SEARCH</Title>
          <AddressSearch type="places" onSelect={setAddressResult} />
          <Paragraph>{JSON.stringify(addressResult)}</Paragraph>
        </AddressSearchContainer>
        <ListingSearchContainer>
          <Title>LISTING SEARCH</Title>
          <AddressSearch type="listing" onSelect={setListingResult} />
          <Paragraph>{JSON.stringify(listingResult)}</Paragraph>
        </ListingSearchContainer>
        <ContactSearchContainer>
          <Title>CONTACT SEARCH</Title>
          <ContactSearch
            contacts={contacts}
            value={partner?.id}
            onChange={setPartner}
          />
        </ContactSearchContainer>
        <Contact
          contact={contact}
          loading={loading}
          type={ContactDrawerType.Contact}
        />
      </LeftContainer>
      <IconSectionContainer>
        <Title>ICONS</Title>
        <IconListContainer>
          {Object.keys(iconLibrary).map(iconName => (
            <IconContainer key={iconName}>
              <Icon type={iconName as IconNameType} height={24} width={24} />
              <IconText>{iconName}</IconText>
            </IconContainer>
          ))}
        </IconListContainer>
      </IconSectionContainer>
    </Container>
  );
};

export default DevPage;

const LeftContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex: 1;
  align-items: flex-start;
`;

const Container = styled(Layout.Content)`
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  flex: 1;
  align-items: flex-start;
`;

const IconSectionContainer = styled.div``;

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 175px;
  height: 100px;
`;

const AddressSearchContainer = styled.div``;

const ListingSearchContainer = styled.div``;

const ContactSearchContainer = styled.div``;

const IconListContainer = styled.div`
  flex: 1;
  display: flex;
  flex-wrap: wrap;
`;
